import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { COMPLIANCE_NAMESPACE } from '@/i18n'

const linkClass = ({ isActive }: { isActive: boolean }) =>
	isActive
		? 'rounded-ds-md bg-ds-primary px-3 py-1 text-ds-sm text-ds-on-primary'
		: 'rounded-ds-md px-3 py-1 text-ds-sm text-ds-text hover:bg-ds-surface-muted'

/** The compliance heading and its two pages (TO-232; the admin menu links only to Deletions). */
export function ComplianceNav() {
	const { t } = useTranslation(COMPLIANCE_NAMESPACE)
	return (
		<header className="flex flex-col gap-3">
			<h1 className="text-ds-xl font-semibold text-ds-text">{t('nav.title')}</h1>
			<nav aria-label={t('nav.label')} className="flex gap-2">
				<NavLink to="/admin/compliance/deletions" className={linkClass}>
					{t('nav.deletions')}
				</NavLink>
				<NavLink to="/admin/compliance/sars" className={linkClass}>
					{t('nav.sars')}
				</NavLink>
			</nav>
		</header>
	)
}
